


function Footer() {

  const userData = JSON.parse(sessionStorage.getItem("userData"));

  return (
    <>
      {!userData.userData ? null :
        <div

          className="pclp-footer"
        >
          
          <div>
              <p>Rentabilidades pasadas no garantizan rentabilidades futuras.</p><p>Ondara Capital, S.L. (B67229757) y Vern Properties, S.L. (B02980639) son empresas del Grupo Ondara. Ondara Capital, S.L. es una sociedad, regulada, supervisada y registrada en el Banco de España con el código de Entidad D552. </p><p> We Make Sure. © {new Date().getFullYear()} Ondara.</p></div>
          </div>

      }
    </>
  );
};

export default Footer;